import { gql } from '@apollo/client'

export const lowSecurityTenantNames = gql`
  query getLowSecurityTenantNames {
    lowSecurityTenantNames {
      tenantName
      personId
    }
  }
`

export const taskByUuid = gql`
  query getTasks($favurUuid: String!) {
    task(favurUuid: $favurUuid) {
      person {
        id
        tenant {
          name
        }
      }
    }
  }
`
